import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=34323f1b&scoped=true"
import script from "./DeleteModal.vue?vue&type=script&lang=js"
export * from "./DeleteModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteModal.vue?vue&type=style&index=0&id=34323f1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34323f1b",
  null
  
)

export default component.exports